﻿import angular from 'angular';

angular.module('folkeuni').component('fuModal', {
  controller: function($scope) {
    var $ctrl = this;
    $ctrl.open = false;
    $ctrl.headline = "";
    $ctrl.content = "";
    $ctrl.actions = [];
    $ctrl.closing = false;
    $ctrl.closeCB = null;
    
    $ctrl.$onInit = function() {
      window.addEventListener('CreateModal', function(e) {
        $ctrl.openModal(e.detail);
        try {
          $scope.$digest();
        } catch(err){};
      });
    }

    $ctrl.openModal = function({headline, content, actions = [], close = null}) {
      $ctrl.open = true;
      $ctrl.headline = headline;
      $ctrl.content = content;
      $ctrl.actions = actions;
      $ctrl.closeCB = close;
      document.body.style.overflow = 'hidden';
    }

    $ctrl.closeModal = function() {
      $ctrl.closing = true;
      if ($ctrl.closeCB) $ctrl.closeCB();

      setTimeout(function () {
        $ctrl.resetModal();
        try {
          $scope.$digest();
        } catch(err){};
      }, 400);
    }

    $ctrl.resetModal = function() {
      $ctrl.open = false;
      $ctrl.headline = "";
      $ctrl.content = "";
      $ctrl.actions = [];
      $ctrl.closing = false;
      $ctrl.closeCB = null;
      document.body.style.overflow = 'visible';
    }
  },
  templateUrl: '/shop-dist/templates/modal.html?c=' + window.cacheBurst,
});